import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { AddOutcomeToProjectModalPage } from './add-outcome-to-project-modal.page';

const routes: Routes = [
  {
    path: '',
    component: AddOutcomeToProjectModalPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [AddOutcomeToProjectModalPage]
})
export class AddOutcomeToProjectModalPageModule {}
